<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.basic100
        v-row(no-gutters)
          //- v-col.shrink.mr-3.pt-1
          //-   v-btn.mr-n2(text icon @click="showModal = !showModal" height)
          //-     eva-icon.ma-1(name="close" :fill="$vuetify.theme.themes[$theme].danger500" height="30")
          v-col.align-self-center
            p.mb-0.h6.danger500--text {{ $t('delete_title') }}
      v-divider.basic300
      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card(v-else-if="!isFetching")
            .has-pending-bills(v-if="$store.state.subscriptions.hasPendingBills")
              v-card-text.pa-5
                div.p1 {{ $t('sorry_have_pending_payment', { name: this.company.name }) }}
              v-card-actions.px-6.pb-6
                v-spacer
                v-btn(text @click='showModal = false')
                  .button-AA-small.primary400--text| {{ $t('cancel') }}
                v-btn.mr-2(color='textColorAccent' depressed height=32 @click="openBillList")
                  .button-AA-small.basic100--text| {{ $t('view_bills') }}

            .yearly(v-else-if="yezzaSubscription.value && yezzaSubscription.data.contract.period == 'one_year'")
              v-card-text.pa-5
                div.p1 {{ $t('sorry_subscribed_yearly') }}
                  b  {{ yezzaSubscription.data.contract_end_date | humanizeDateLong }}
                  span . {{ $t('sorry_subscribed_yearly_contact') }}
              v-card-actions.px-6.pb-6
                v-spacer
                v-btn(text @click='showModal = false')
                  .button-AA-small.primary400--text| {{ $t('cancel') }}
                v-btn.mr-2(color='danger500' depressed height=32 @click="sendEmail")
                  .button-AA-small.basic100--text| {{ $t('contact_support') }}
            .monthly-or-not(v-else)
              v-window(v-model="step" touchless)
                v-window-item(:value="1")
                  v-card-text.pa-5
                    div.p1 {{ $t('do_you_really_want') }}&nbsp;
                      strong {{ company.name }}?&nbsp;
                    div.p1.mt-2 {{ $t('we_like_to_ask') }}
                  v-card-actions.px-4.pb-4
                    v-spacer
                    v-btn(text @click='showModal = false' depressed height=32)
                      .button-AA-small.primary400--text| {{ $t('cancel') }}
                    v-btn(color='textColorAccent' depressed height=32 :loading="isLoading" @click='step++')
                      .button-AA-small.basic100--text| {{ $t('start') }}

                v-window-item(:value="2")
                  v-card-text
                    div.s1.mb-3 {{ $t('q1_question') }}
                    template(v-for="answer in q1_answers")
                      v-card.my-1(outlined @click="answers.business_category = answer.ans")
                        v-row(no-gutters)
                          v-col.pa-1.shrink
                            v-icon {{ answer.icon }}{{ answers.business_category === answer.ans ? '' : '-outline' }}
                          v-col.pa-1.align-self-center
                            div.p2.my-auto {{ answer.ans }}
                          v-col.pa-1.shrink.align-self-center(v-if="answers.business_category === answer.ans")
                            v-icon(color="primary400") mdi-check
                  v-card-actions.px-4.pb-4
                    v-btn(text depressed height=32 @click='step--')
                      .button-AA-small.primary400--text {{ $t('back') }}
                    v-spacer
                    v-btn(color='textColorAccent' depressed height=32 @click='step++' :disabled="!answers.business_category")
                      .button-AA-small.basic100--text {{ $t('next') }}

                v-window-item(:value="3")
                  v-card-text
                    div.s1.mb-3 {{ $t('q2_question') }}
                    template(v-for="answer in q2_answers")
                      v-card.my-1(outlined @click="answers.reason = answer.ans")
                        v-row(no-gutters)
                          v-col.pa-1.shrink
                            v-icon {{ answer.icon }}{{ answers.reason === answer.ans ? '' : '-outline' }}
                          v-col.pa-1.align-self-center
                            div.p2.my-auto {{ answer.ans }}
                          v-col.pa-1.shrink.align-self-center(v-if="answers.reason === answer.ans")
                            v-icon(color="primary400") mdi-check
                  v-card-actions.px-4.pb-4
                    v-btn(text depressed height=32 @click='step--')
                      .button-AA-small.primary400--text {{ $t('back') }}
                    v-spacer
                    v-btn(color='textColorAccent' depressed height=32 @click='step++' :disabled="!answers.reason")
                      .button-AA-small.basic100--text {{ $t('next') }}
                    //- template(v-if="answers.reason === 'I have another company in Yezza'")
                      v-btn(color='textColorAccent' depressed height=32 @click='step = step + 3' :disabled="!answers.reason")
                        .button-AA-small.basic100--text submit
                    //- template(v-else)

                v-window-item(:value="4")
                  v-card-text
                    div.s1.mb-1 {{ $t('q3_question') }} 
                    div.p2.mb-3.primary400--text {{ $t('q3_question_text') }}
                    template(v-for="answer in q3_answers")
                      v-card.my-1(outlined @click="answers.assist = answer.ans")
                        v-row(no-gutters)
                          v-col.pa-1.shrink
                            v-icon {{ answer.icon }}{{ answers.assist === answer.ans ? '' : '-outline' }}
                          v-col.pa-1.align-self-center
                            div.p2.my-auto {{ answer.ans }}
                          v-col.pa-1.shrink.align-self-center(v-if="answers.assist === answer.ans")
                            v-icon(color="primary400") mdi-check
                  v-card-actions.px-4.pb-4
                    v-btn(text depressed height=32 @click='step--')
                      .button-AA-small.primary400--text {{ $t('back') }}
                    v-spacer
                    template(v-if="answers.assist === 'Yes'")
                      v-btn(color='textColorAccent' depressed height=32 @click="submitDeleteForm(); step++" :disabled="!answers.assist")
                        .button-AA-small.basic100--text {{ $t('submit') }}
                    template(v-else-if="answers.assist === 'No'")
                      v-btn(color='textColorAccent' depressed height=32 @click='step = step + 2' :disabled="!answers.assist")
                        .button-AA-small.basic100--text {{ $t('submit') }}

                v-window-item(:value="5")
                  v-card-text.px-4.pb-4
                    div.s1.mb-0 {{ $t('question_thank_you') }}
                  v-card-actions.px-4.pb-4
                    v-spacer
                    v-btn(text @click='showModal = false' depressed height=32)
                      .button-AA-small.primary400--text {{ $t('close') }}

                v-window-item(:value="6")
                  v-card-text.px-4.pb-4
                    div {{ $t('confirm_type_company_name') }}
                    v-text-field.mt-3(v-model='companyName' :placeholder="$t('company_name.placeholder')" odense outlined height="40" background-color="basic200" persistent-hint hide-details :rules="rules.not_empty")
                  v-card-actions.px-4.pb-4
                    v-spacer
                    v-btn(text @click='showModal = false' depressed height=32)
                      .button-AA-small.primary400--text| {{ $t('cancel') }}
                    v-btn(color='danger500' depressed height=32 :loading="isLoading" @click='clickConfirm')
                      .button-AA-small.basic100--text {{ $t('confirm') }}

</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'DeleteCompany',
    props: ['open', 'company'],
    data: () => ({
      fullscreen: true,
      isFetching: false,
      isLoading: false,
      companyName: '',
      step: 1,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        agreedTerm: [
          v => !!v || 'You must agree with with Yezza Terms'
        ]
      },
      answers: {
        business_category: '',
        reason: '',
        assist: ''
      },
      q1_answers: [
        { icon: 'mdi-alpha-a-box', ans: 'Products (dry food, fashion, homeware, etc)' },
        { icon: 'mdi-alpha-b-box', ans: 'Services (medical, consultation, insurance)' },
        { icon: 'mdi-alpha-c-box', ans: 'Food and Beverages (cooked/prepared food and beverages)' },
        { icon: 'mdi-alpha-d-box', ans: 'Digital Products' },
        { icon: 'mdi-alpha-e-box', ans: 'Physical Store / Shop' }
      ],
      q2_answers: [
        { icon: 'mdi-alpha-a-box', ans: "I can't afford Yezza subscription fees." },
        { icon: 'mdi-alpha-b-box', ans: "I don't get customers on Yezza." },
        { icon: 'mdi-alpha-c-box', ans: 'I accidentally subscribed to Yezza.' },
        { icon: 'mdi-alpha-d-box', ans: "I don't have an actual business yet." },
        { icon: 'mdi-alpha-e-box', ans: 'It is difficult to use Yezza system.' },
        { icon: 'mdi-alpha-f-box', ans: "I don't know how to do marketing." },
        { icon: 'mdi-alpha-g-box', ans: 'Yezza does not have the features that I need.' },   
        { icon: 'mdi-alpha-h-box', ans: "I don't know how to begin." }
        // { icon: 'mdi-alpha-d-box', ans: 'I did not receive support or guidance.' },
        // { icon: 'mdi-alpha-e-box', ans: 'Yezza is not suitable for my business anymore.' },
        // { icon: 'mdi-alpha-h-box', ans: 'I have another company in Yezza' }
      ],
      q3_answers: [
        { icon: 'mdi-alpha-y-box', ans: 'Yes' },
        { icon: 'mdi-alpha-n-box', ans: 'No' }
      ]
    }),
    computed: {
      ...mapState('user', ['member']),
      ...mapState('subscriptions', ['yezzaSubscription']),
      showModal: {
        get() {
          return this.open
        },
        set(newValue) {
          this.$emit('update:open', newValue)
        }
      }
    },
    mounted () {
      this.fullscreen = window.innerWidth < 600
      this.fetchPendingBills()
    },
    created () {
      this.fetchSettings()
    },
    methods: {
      ...mapActions([
        'showMessage'
      ]),
      sendEmail() {
        window.open(`mailto:support@yezza.io?subject=Delete Company &body= %0D%0A %0D%0A %0D%0A Company: ${window.location.href} %0D%0A %0D%0A Regards, %0D%0A ${this.member.user.first_name + ' ' + this.member.user.last_name}`, '_blank')
        this.showModal = false
      },
      fetchPendingBills () {
        let url = `/subscription/bills/?page=1&page_size=12&company=${this.company.id}&ordering=-created&paid=false`
        this.$axios.get(url)
          .then((response) => {
            const totalCount = response.data.count
            this.$store.commit('subscriptions/setHasPendingBills', totalCount != 0)
          })
          .catch(() => {})
      },
      openBillList() {
        this.$router.push('/admin/billing/bills/')
      },
      submitDeleteForm () {
        let params = {
          company: this.company.id,
          type: 'churn-feedback',
          data: {
            company: this.company.name,
            email: this.member.user.email,
            phone: this.member.phone,
            answer: this.answers
          }
        }
        this.$axios.post('/requests/', params)
          .catch(() => {
            this.showMessage(['alert', 'Error submit form'])
          })
      },
      clickConfirm() {
        if (!this.$refs.form.validate()) {
          return
        }
        if (this.companyName !== this.company.name) {
          this.showMessage(['alert', 'Company name not correct'])
          return
        }
        this.axios.patch(`/companies/${this.company.id}/`, { status: 4 })
          .then(() => {
            this.submitDeleteForm()
            this.$router.push('/companies')
            this.$logEvent('company.deleted')
          })
          .catch(() => {
            this.showMessage(['alert', 'Error deleting company'])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "delete_title": "Delete company",
    "company_name" : {
      "label": "Company name",
      "placeholder": "Type company name to confirm"
    },
    "do_you_really_want": "Do you really want to delete",
    "we_like_to_ask": "We’d like to ask you just a few questions before you delete this company.",
    "sorry_have_pending_payment": "We are very sorry. It seems that {name} still have pending payment.",
    "view_bills": "View bills",
    "sorry_subscribed_yearly": "We are very sorry. It seems that you have subscribed to a yearly contract that will end on",
    "sorry_subscribed_yearly_contact": "Please contact our support team if you really wish to terminate your account.",
    "contact_support": "Contact Support",
    "q1_question": "What is your business category?",
    "q2_question": "What is your main reason to unsubscribe?",
    "q3_question": "We are sorry to hear that.. Would you like to give Yezza a last chance to assist you?",
    "q3_question_text": "By choosing \"Yes\", our Yezza Support team will give you a free 30 minute personal coaching to offer you a possible solution.",
    "question_thank_you": "Thank You! Lets make this work once and for all. Our support team will contact you as soon as possible",
    "confirm_type_company_name": "Type your company name below to confirm deletion."
  },
  "id": {
    "delete_title": "Hapus Perusahaan",
    "company_name" : {
      "label": "Nama Perusahaan",
      "placeholder": "Tulis nama perusahaan untuk konfirmasi"
    },
    "do_you_really_want": "Apakah kamu yakin ingin menghapus",
    "we_like_to_ask": "Kami ingin mengajukan beberapa pertanyaan sebelum kamu menghapus perusahaan ini.",
    "sorry_have_pending_payment": "Maaf, Tampaknya {name} masih memiliki pembayaran yang tertunda.",
    "view_bills": "Lihat Bil",
    "sorry_subscribed_yearly": "Kami sangat menyesal. Sepertinya kamu telah berlangganan paket tahunan yang akan berakhir pada",
    "sorry_subscribed_yearly_contact": "Silakan hubungi tim dukungan kami jika kamu benar-benar ingin menghentikan akun kamu.",
    "contact_support": "Hubungi support",
    "q1_question": "Apa kategori bisnis kamu??",
    "q2_question": "Apa alasan utama kamu untuk berhenti berlangganan??",
    "q3_question": "Kami menyesal mendengarnya.. Apakah kamu ingin memberi Yezza kesempatan terakhir untuk membantu kamu?",
    "q3_question_text": "Dengan memilih \"Ya\", tim Dukungan Yezza kami akan memberi kamu pelatihan pribadi gratis selama 30 menit untuk menawarkan solusi yang memungkinkan.",
    "question_thank_you": "Terima kasih! Mari kita membuat ini bekerja sekali dan untuk semua. Tim dukungan kami akan menghubungi kamu sesegera mungkin",
    "confirm_type_company_name": "Ketik nama perusahaan kamu di bawah ini untuk mengonfirmasi penghapusan."
  }
}
</i18n>